'use client'

// Import and re-export the MediaGallery component defined in this file
import { MediaGallery as LocalMediaGallery } from './media/core/MediaGallery';
export { LocalMediaGallery as MediaGallery };

// Re-export all components from media subdirectories
    export { MediaDropzone } from './media/core/MediaDropzone';
  export { MediaPreview } from './media/core/MediaPreview';
  export { MediaThumbnail } from './media/core/MediaThumbnail';
  export { ThumbnailGallery } from './media/core/ThumbnailGallery';

// Editor components
export { MediaEditor } from './media/editor/MediaEditor';
export { MediaMetadataForm } from './media/editor/MediaMetadataForm';

// Upload components
export { UploadPreview } from './media/upload/UploadPreview';
export { UploadProgress } from './media/upload/UploadProgress';

// Composite components
export { MediaField } from './media/composite/MediaField';
export { MediaModal } from './media/composite/MediaModal';
export { MediaPicker } from './media/composite/MediaPicker';

